export default __webpack_public_path__ + "static/media/bg.149491cd.webp";